import React, { useState, useCallback, Fragment, useEffect, } from "react";
import { ChromePicker } from "react-color";
import { FormControl } from "react-bootstrap";
import { useFormContext } from "./Form";
import { observer } from "mobx-react-lite";
import { withFormWrapper, DEFAULT_ID, emptyStringIfNull, } from "./withFormWrapper";
import { keyPress } from "./utils/keyPress";
import { StaticInputValue } from "./StaticInput";
export var RawColourPicker = observer(function (_a) {
    var _b;
    var name = _a.name, disabled = _a.disabled, onChange = _a.onChange, _c = _a.uniqueId, uniqueId = _c === void 0 ? DEFAULT_ID : _c, label = _a.label, staticFormatter = _a.staticFormatter, dataId = _a.dataId, dataLabel = _a.dataLabel, dataTestId = _a.dataTestId;
    var _d = useFormContext(), values = _d.values, formDisabled = _d.formDisabled, isStatic = _d.isStatic;
    var _e = useState(false), showPicker = _e[0], setShowPicker = _e[1];
    var handlePickerChange = useCallback(function (_a) {
        var hex = _a.hex;
        onChangeSetValue(onChange, hex, values, name);
    }, [onChange, name, values]);
    var handleChange = React.useCallback(function (e) {
        onChangeSetValue(onChange, e.target.value, values, name);
    }, [onChange, values, name]);
    var keyFunctions = useCallback(function (event) {
        if (event.keyCode === keyPress.ESCAPE ||
            event.keyCode === keyPress.ENTER) {
            setShowPicker(false);
        }
        if (event.keyCode === keyPress.BACKSPACE ||
            event.keyCode === keyPress.DELETE) {
            values.set(name, "");
        }
    }, [values, name]);
    useEffect(function () {
        if (showPicker) {
            document.addEventListener("keydown", keyFunctions, false);
        }
        return function () {
            if (showPicker) {
                document.removeEventListener("keydown", keyFunctions, false);
            }
        };
    }, [showPicker, keyFunctions]);
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    return (React.createElement(Fragment, null,
        React.createElement(FormControl, { name: name, value: emptyStringIfNull(values.get(name)), disabled: disabled || formDisabled, onSelect: function () { return setShowPicker(!disabled); }, id: "form-group-".concat(name, "-").concat(uniqueId), onChange: handleChange }),
        showPicker ? (React.createElement("div", { style: { position: "absolute", zIndex: 1051 } },
            React.createElement("div", { style: {
                    position: "fixed",
                    top: "0px",
                    right: "0px",
                    bottom: "0px",
                    left: "0px",
                }, onClick: function () { return setShowPicker(false); } }),
            React.createElement(ChromePicker, { color: (_b = values.get(name)) !== null && _b !== void 0 ? _b : "", onChange: handlePickerChange }))) : null));
});
export var ColourPicker = withFormWrapper({
    WrappedComponent: RawColourPicker,
});
function onChangeSetValue(onChange, newValue, values, name) {
    if (onChange) {
        onChange(newValue, values.get(name));
    }
    values.set(name, newValue);
}
